import { gql } from '@apollo/client';

export * from './escrowInvitationAccept.mutation.generated';

export const ESCROW_INVITATION_ACCEPT = gql`
  mutation escrowInvitationAccept($escrowInvitationId: ID!) {
    escrowInvitationAccept(input: { escrowInvitationId: $escrowInvitationId }) {
      success
      errors
    }
  }
`;
